class TabChange {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const trigger = document.querySelectorAll(".tabChangeLink");
    const panel = document.querySelectorAll(".tabChangePanel");
    
    // 全てのtabChangeLinkのクラス、番号を取得
    trigger.forEach((item, index) => {
      
      // tabChangeLinkをクリックした時
      item.addEventListener('click', () => {
        const triggerIndex = index;
        const triggerItem = item;
        const getTrigger = document.querySelectorAll(".tabChangeLink");
        getTrigger.forEach((item, index) => {
          item.classList.remove('is-active');
        });
        // 全てのtabChangePanelを取得
        panel.forEach((item, index) => {
          // もし取得した番号が完全に一致したら
          item.classList.remove('is-active');
          if( triggerIndex === index ){
            item.classList.add('is-active');
            triggerItem.classList.add('is-active');
          }
        });
      });
    });
  }
}